import React, { useState } from "react";
import { convertToShortDate, formatCurrency } from "utils";
import { toEmoji } from "utils/tomoEmoji";

// note: using actual images to ensure consistent display between iOS and google emoji
const CATEGORY_ICON_MAP = {
  "Mobile Phone": toEmoji("☎️", 36),
  "Utilities": toEmoji("🛠️", 36),
  "Internet": toEmoji("🌐", 36),
  "Internet / Broadband Charges": toEmoji("🌐", 36),
  "Television": toEmoji("📺", 36),
  "default": toEmoji("🛠️", 36),
};

const PaymentHistoryItem = ({ className = "", item, reported }) => {
  const {
    amount,
    posteddate,
    description,
    normalizedpayee,
    category,
  } = item;
  return (
    <div className={`${className} my-2 mx-auto`} style={{ maxWidth: "360px" }}>
      <div className="rounded-lg common-container text-left border-solid border-gray-400 border-2 bg-transparent">
        <div className="flex flex-row justify-between">
          <div className="flex flex-row items-center box-content">
            {CATEGORY_ICON_MAP[category] || CATEGORY_ICON_MAP.default}
            <div className="ml-5">
              <div>
                <p className="font-semibold">{normalizedpayee || description}</p>
              </div>
              <div>{convertToShortDate(new Date(posteddate * 1000))}</div>
            </div>
          </div>
          <div className="flex flex-col justify-center text-center">
            <div>{formatCurrency(amount)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const INITIAL_NUM_ITEMS = 2;

const PaymentHistory = ({ items = [], reported, setShowSelfAdd, hasBankAccounts }) => {
  const [showAll, setShowAll] = useState(false);

  // sort items by posted date
  const sortedItems = items.sort((a, b) => b.posteddate - a.posteddate);

  const firstTen = sortedItems.slice(0, INITIAL_NUM_ITEMS);
  const rest = sortedItems.slice(INITIAL_NUM_ITEMS);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="">
      {firstTen?.map((item) => (
        <PaymentHistoryItem item={item} key={item.id} reported={reported} />
      ))}
      {!!rest?.length && (
        <button
          className="mt-5 text-white hover:underline hover:cursor-pointer focus:outline-none"
          type="button"
          onClick={toggleShowAll}
        >
          {showAll ? "see less -" : "see more +"}
        </button>
      )}
      {hasBankAccounts && (
        <div className="my-5">
          <button
            type="button"
            onClick={() => {
              setShowSelfAdd(true);
            }}
            className="bg-white text-black hover:text-boost-primary rounded-xl px-4 py-1 focus:outline-none"
          >
            + Don&apos;t See Your Bills?
          </button>
        </div>
      )}
      {showAll && rest?.map((item) => (
        <PaymentHistoryItem item={item} key={item.id} reported={reported} />
      ))}
    </div>
  );
};

const UtilityHistory = ({ utilities, hasUnreportedTransactions, setShowSelfAdd, hasBankAccounts }) => {
  return (
    <div className="mt-10 w-full border-2 border-white rounded-xl border-glow-white-sharp p-5 bg-black bg-opacity-50">
      <div className="text-2xl font-semibold text-boost-lighter-purple text-left">
        Bills<span className="text-white">.</span>
      </div>
      <div className="text-left mb-5">that are boosting your credit</div>
      <PaymentHistory
        items={utilities}
        reported={!hasUnreportedTransactions}
        setShowSelfAdd={setShowSelfAdd}
        hasBankAccounts={hasBankAccounts}
      />
    </div>
  );

};

export default UtilityHistory;
